import { Button, ButtonProps } from '@/components/ui/button';
import { usePermissions, Permission } from '@/hooks/use-permissions';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface PermissionButtonProps extends ButtonProps {
  permission: Permission | Permission[];
  fallbackText?: string;
  children: React.ReactNode;
}

export function PermissionButton({ 
  permission, 
  fallbackText, 
  children, 
  disabled,
  ...props 
}: PermissionButtonProps) {
  const { hasPermission, hasAnyPermission } = usePermissions();
  
  const hasRequiredPermission = Array.isArray(permission) 
    ? hasAnyPermission(permission)
    : hasPermission(permission);
  
  const isDisabled = disabled || !hasRequiredPermission;
  
  if (!hasRequiredPermission && fallbackText) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button {...props} disabled={true}>
              {children}
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>{fallbackText}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
  
  return (
    <Button {...props} disabled={isDisabled}>
      {children}
    </Button>
  );
}
